import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";

import AS from "../Login/Service/Authentication";
import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";

import PageTitle from "../../commons/components/PageTitle";
import AddressSearch from "../../commons/components/AddressSearch";
import { ROUTES } from "../../commons/constants/routes/routes";
import InputErrorMsgWrapper from "../../commons/components/input/InputErrorWrap";
import { withTranslation } from "react-i18next";
import { InputTitleWidth } from "./tanslationUiConst";

class ProjectCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addrxy: { addr: "", x: "", y: "" },
      isSaved: false,
      validationErrors: {},
      siteManagers: [],
      siteNo: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setAddrXY = this.setAddrXY.bind(this);
    this.checkAddressValidation = this.checkAddressValidation.bind(this);
    this.handleFacilityRegistration = this.handleFacilityRegistration.bind(this);
    this.handleGenerateSiteNo = this.handleGenerateSiteNo.bind(this);
  }

  async componentDidMount() {
    try {
      const res = await axios.get("/api/account/account", { params: { userType: "USR_S" } });
      this.setState({ siteManagers: res.data.data || [] });
    } catch (e) {
      console.log(e);
    }
  }

  validateForm(data) {
    const validationErrors = {};

    if (!data.get("name")) {
      validationErrors.name = "프로젝트명을 입력해주세요.";
    } else if (!VS.isLengthValid({ str: data.get("name"), max: 36 })) {
      validationErrors.name = "프로젝트명은 36자 이하여야 합니다.";
    }
    if (!data.get("address")) {
      validationErrors.address = "프로젝트 주소를 입력해주세요.";
    }
    if (!data.get("addressDetail")) {
      validationErrors.addressDetail = "상세주소를 입력해주세요.";
    }
    if (!data.get("siteNo")) {
      validationErrors.siteNo = "Site 번호를 입력해주세요.";
    }
    if (!data.get("customerName")) {
      validationErrors.customerName = "고객명을 입력해주세요.";
    }
    if (!data.get("customerPhone")) {
      validationErrors.customerPhone = "고객 전화번호를 입력해주세요.";
    }
    if (data.get("customerEmail") && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.get("customerEmail"))) {
      validationErrors.customerEmail = "올바른 이메일 형식이 아닙니다.";
    }

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();
    const isSaved = await this.saveProject();
    if (isSaved) {
      this.setState({ isSaved: true });
      const data = new FormData(document.querySelector("form"));
      this.props.history.push({
        pathname: ROUTES.PLANT_LIST(this.state.newId).MAIN,
        state: { projectTitle: data.get("name") },
      });
    }
  }

  async handleFacilityRegistration(e) {
    e.preventDefault();
    const data = new FormData(document.querySelector("form"));
    const name = data.get("name");

    if (this.state.isSaved) {
      this.props.history.push({
        pathname: ROUTES.PLANT_LIST(this.state.newId).MAIN,
        state: { projectTitle: name },
      });
      return;
    }

    const isSaved = await this.saveProject();
    if (isSaved) {
      this.setState({ isSaved: true });
      this.props.history.push({
        pathname: ROUTES.PLANT_LIST(this.state.newId).MAIN,
        state: { projectTitle: name },
      });
    }
  }

  async saveProject() {
    const data = new FormData(document.querySelector("form"));
    if (!this.validateForm(data)) return false;

    const item = {
      constructorId: AS.getLoggedInId(),
      name: data.get("name"),
      address: data.get("address"),
      addressDetail: data.get("addressDetail"),
      siteNo: data.get("siteNo") || null,
      latY: this.state.addrxy.y,
      lngX: this.state.addrxy.x,
      customerName: data.get("customerName"),
      customerPhone: data.get("customerPhone"),
      customerEmail: data.get("customerEmail") || null,
      ...(data.get("siteManagerId") ? { siteManagerId: data.get("siteManagerId") } : {}),
    };

    try {
      const result = await CS.create("/cst/api/project", item);
      if (result.isSuccess) {
        this.setState({ newId: result.res.data });
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  setAddrXY(address, longitude, latitude) {
    const { validationErrors } = this.state;
    delete validationErrors.address;
    this.setState({
      addrxy: { addr: address, x: longitude, y: latitude },
      validationErrors,
    });
  }

  checkAddressValidation(e) {
    alert("주소 검색을 이용해서 현장 주소를 입력해주세요.");
    e.target.blur();
  }

  async handleGenerateSiteNo() {
    const addr = this.state.addrxy.addr;
    if (!addr) {
      alert("먼저 주소를 검색해 주세요.");
      return;
    }
    try {
      // 1. 카카오 API로 법정동 코드(b_code) 조회
      let bcode = "";
      try {
        sessionStorage.setItem("kakao", "true");
        const kakaoRes = await axios.get(
          `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURIComponent(addr)}`
        );
        bcode = kakaoRes.data.documents[0]?.address?.b_code || "";
      } finally {
        sessionStorage.removeItem("kakao");
      }

      if (!bcode) {
        alert("법정코드를 가져올 수 없습니다.");
        return;
      }

      // 2. 동일 법정동코드(10자리)의 기존 최대 siteNo 조회
      const maxRes = await axios.get("/api/project/search-by-site-no/max", {
        params: { siteNo: bcode },
      });
      const maxSiteNo = maxRes.data?.result;

      // 3. 최대값이 있으면 +1, 없으면 법정동코드 + "00001"
      const newSiteNo = maxSiteNo
        ? String(Number(maxSiteNo) + 1)
        : bcode + "00001";

      const { validationErrors } = this.state;
      delete validationErrors.siteNo;
      this.setState({ siteNo: newSiteNo, validationErrors });

    } catch (e) {
      alert("Site 번호 생성 중 오류가 발생했습니다.");
    }
  }

  render() {
    const { validationErrors, siteManagers } = this.state;
    const { t, i18n } = this.props;

    return (
      <>
        <PageTitle title={t('key51')} location={t('key52')} />
        <FormWapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>{t('key53')}</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.name} message={validationErrors.name}>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className="comm-inp"
                    placeholder={t('key54')}
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      if (!VS.isLengthValid({ str: e.target.value, max: 36 })) {
                        validationErrors.name = "프로젝트명은 36자 이하여야 합니다.";
                      } else {
                        delete validationErrors.name;
                      }
                      this.setState({ validationErrors });
                      VS.characterCheck(e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>{t('key55')}</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.address} message={validationErrors.address}>
                  <input
                    type="text"
                    name="address"
                    id="address"
                    className="comm-inp"
                    placeholder={t('key56')}
                    defaultValue={this.state.addrxy.addr}
                    onFocus={this.checkAddressValidation}
                  />
                </InputErrorMsgWrapper>
                <AddressSearch setAddrXY={this.setAddrXY} />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>상세주소</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.addressDetail} message={validationErrors.addressDetail}>
                  <input
                    type="text"
                    name="addressDetail"
                    className="comm-inp"
                    placeholder="상세주소를 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.addressDetail;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>Site 번호</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.siteNo} message={validationErrors.siteNo}>
                  <input
                    type="text"
                    name="siteNo"
                    className="comm-inp"
                    placeholder="Site 번호를 입력하세요"
                    value={this.state.siteNo}
                    onChange={(e) => {
                      VS.onInput("number", e);
                      const { validationErrors } = this.state;
                      delete validationErrors.siteNo;
                      this.setState({ siteNo: e.target.value, validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
                <button
                  type="button"
                  className="btn primary w150 ml-10"
                  onClick={this.handleGenerateSiteNo}
                >
                  Site 번호 생성
                </button>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>고객명</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.customerName} message={validationErrors.customerName}>
                  <input
                    type="text"
                    name="customerName"
                    className="comm-inp"
                    placeholder="고객명을 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.customerName;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)} required={true}>고객 전화번호</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.customerPhone} message={validationErrors.customerPhone}>
                  <input
                    type="text"
                    name="customerPhone"
                    className="comm-inp"
                    placeholder="고객 전화번호를 입력하세요"
                    onChange={(e) => {
                      const { validationErrors } = this.state;
                      delete validationErrors.customerPhone;
                      this.setState({ validationErrors });
                      VS.onInput("phone", e);
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)}>고객 이메일</FormHead>
              <FormBody>
                <InputErrorMsgWrapper isError={validationErrors.customerEmail} message={validationErrors.customerEmail}>
                  <input
                    type="text"
                    name="customerEmail"
                    className="comm-inp"
                    placeholder="고객 이메일을 입력하세요"
                    onChange={() => {
                      const { validationErrors } = this.state;
                      delete validationErrors.customerEmail;
                      this.setState({ validationErrors });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead width={InputTitleWidth(i18n)}>현장 관리자</FormHead>
              <FormBody>
                <select name="siteManagerId" className="comm-inp comm-select">
                  <option value="">선택 안 함</option>
                  {siteManagers.map((m) => (
                    <option key={m.id} value={m.id}>{m.userName}</option>
                  ))}
                </select>
              </FormBody>
            </FormBox>
          </FormContainer>

          <BtnGroup>
            <button type="button" className="cancel-btn" onClick={() => this.props.history.push(ROUTES.PROJECT.MAIN)}>
              취소
            </button>
            <button type="button" onClick={this.handleFacilityRegistration}>
              {t('key60')}
            </button>
            <button type="submit">{t('key61')}</button>
          </BtnGroup>
        </FormWapper>
      </>
    );
  }
}

const FormWapper = styled.form``;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
`;
const FormHead = styled.p`
  ${({ width }) => width ? `width: ${width};` : 'width: 140px;'}
  display: inline-block;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  ${({ required }) => required && (
    `&::after {
      content: " *";
      color: #FF5353;
    }`
  )}
`;
const FormBody = styled.div`
  display: inline-block;
  input, select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 436px;
  }
  .comm-select {
    height: 38px;
    border: 1px solid #d5d8de;
    padding: 0 10px;
    font-size: 14px;
  }
`;
const BtnGroup = styled.div`
  max-width: 1176px;
  width: 100%;
  text-align: right;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    &.cancel-btn {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
      margin-right: 12px;
    }
    &:nth-child(2) {
      color: var(--grey-900);
      background-color: transparent;
      border: 1px solid var(--primary-500);
    }
    &:last-child {
      margin-left: 12px;
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
    }
  }
`;

export default withTranslation()(ProjectCreate);
